import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { SerialNumberActivityLevel } from '../../interfaces/consortium/serial-number-activity-level';
import { map, Observable } from 'rxjs';
import { TimelineEvent } from '../../interfaces/consortium/timeline-event';
import { DecodedSerialNumberInformation } from '../../interfaces/consortium/decoded-serial-number-info';
import { TimelineSummary } from '../../interfaces/consortium/timeline-summary';
import { CriminalActivityHit } from '../../interfaces/consortium/criminal-activity-hit';

@Injectable({
  providedIn: 'root'
})
export class ConsortiumService {
  constructor(
    private http: HttpClient,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) { }

  getSerialNumberActivityLevel(serialNumber: string, jurisdiction?: string) {
    let params = new HttpParams();

    if (jurisdiction) {
      params = params.append('jurisdiction', jurisdiction);
    }

    return this.http.get<SerialNumberActivityLevel>(`${this.config.consortiumRootURL}/SerialNumbers/${serialNumber}/ActivityLevel`, { params: params });
  }
  
  getSerialNumberTimeline(serialNumber: string): Observable<TimelineEvent[]> {
    return this.http.get<TimelineEvent[]>(`${this.config.consortiumRootURL}/SerialNumbers/${serialNumber}/Timeline`);
  }

  getSerialNumberTimelineSummary(serialNumber: string): Observable<TimelineSummary[]> {
    return this.http.get<TimelineSummary[]>(`${this.config.consortiumRootURL}/SerialNumbers/${serialNumber}/Timeline/Summary`);
  }

  getDecodedSerialNumberInformation(serialNumber: string): Observable<DecodedSerialNumberInformation> {
    //we use PUT because we may not have actually decoded this serial number before. 
    //the implementation of the PUT on the backend queries for the info locally, if it's not there then it goes out to NHTSA
    return this.http.put<any>(`${this.config.consortiumRootURL}/NHTSADecodedSerialNumberInformation/${serialNumber}`, { observe: 'body '})
      .pipe(map(res => {
        return {
          make: res?.make?.toUpperCase().trim(),
          model: res?.model?.toUpperCase().trim(),
          year: res?.modelYear?.toUpperCase().trim(),
          trim: `${res?.series} ${res?.trim} ${res?.trim2}`.toUpperCase().replaceAll('NULL', '').replaceAll('null', '').trim(),
          errorText: res?.errorText
        }
      }))
  }

  performCriminalActivityCheck(serialNumber: string): Observable<CriminalActivityHit[]> {
    return this.http.post<CriminalActivityHit[]>(`${this.config.consortiumRootURL}/CriminalActivityCheck/${serialNumber}`, null, { observe: 'body' });
  }
}
